import { render, staticRenderFns } from "./instanceTask.vue?vue&type=template&id=0000f24b&"
import script from "./instanceTask.vue?vue&type=script&lang=js&"
export * from "./instanceTask.vue?vue&type=script&lang=js&"
import style0 from "./instanceTask.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports